(function () {
    var scroll = {
        pageHeaderHeight: $('.pageHeader').outerHeight(),
        coolbarHeight: 0,
        pagesNavHeight: 0,
        $coolBar: $('.coolBar'),
        $pagesNav: $('.pages-nav'),
        vPortMd: 'screen-md',
        isVPortMd: false,
        isTablet: false,

        init: function () {
            scroll.control();
        },

        control: function () {
            $(document).on(scroll.vPortMd + '-on', function () {
                scroll.isTablet = true;
            });
            $(document).on(scroll.vPortMd + '-off', function () {
                scroll.isTablet = false;
            });

            // JS code to expand support information section on click
            $("a[href$='#support-information-section']").on('click', function () {
                $('.article-section__supporting a.accordion__control').trigger('click');
            });

            $("a[href$='#open-research-section']").on('click', function () {
                $('.article-section__open-research a.accordion__control').trigger('click');
            });

            $("a[href^='#references-section']").on('click', function () {
                const $this = $(this),
                    $target = $($this.attr('href'));
                if (!$target.closest('.accordion__control').hasClass('js--open')) {
                    $target.closest('.accordion__control').trigger('click');
                }
            });

            $('body').on(
                'click',
                '[data-db-target-of=sections] a, .scrollableLink, .scrollableLinks a, .comment-link a, .PdfLink a[href="#accessDenialLayout"], .article-section__full a[href*="#"]',
                function (e) {
                    const $this = $(this);

                    if (
                        $this.hasClass('open-figure-link') ||
                        $this.hasClass('bibLink') ||
                        $this.hasClass('tab-link') ||
                        $this.closest('.figure__toggle-link').length
                    )
                        return;

                    e.preventDefault();
                    e.stopPropagation();

                    $('body, html').removeClass('lock-screen');
                    if ($this.hasClass('noteLink')) {
                        scroll.openFootNote(this);
                        window.addEventListener('resize', () => {
                            scroll.openFootNote(this);
                        });
                    } else if ($this.hasClass('backToText')) {
                        $($this.attr('href')).focus();
                    } else if (
                        $this.hasClass('goToText') ||
                        $this.closest('.article-header__references-container').length ||
                        $this.attr('href').indexOf('#accessDenialLayout') > -1
                    ) {
                        scroll.scrollToTarget(this, true);
                        $($this.attr('href')).focus();
                    } else {
                        scroll.scrollToTarget(this, true);
                        UX.dropBlock.on.hide();
                        if (scroll.isTablet) {
                            $('[data-db-target-of=sections], .w-slide__back').trigger('click');
                        }
                    }
                    if ($this.parents('.sections__drop.js--open').length) {
                        UX.dropBlock.on.hide();
                    }
                }
            );

            $(document).on('keydown', function (e) {
                if (e.keyCode === 27) {
                    // ESC
                    $('.noteLink.scrollableLink').attr('aria-expanded', 'false');
                    $('.noteLink.scrollableLink').removeAttr('aria-controls');
                    $('.footNotePopup')[0].remove();
                }
            });
        },

        openFootNote: function (noteLink) {
            document.querySelectorAll('.footNotePopup')?.forEach(ele => {
                ele.remove();
            });
            document.querySelectorAll('.noteLink.scrollableLink')?.forEach(ele => {
                ele.setAttribute('aria-expanded', 'false');
            });

            const {noteContainer, chevronDown, noteClose} = scroll.createFootNote(noteLink),
                parentTable = scroll.isNodeInsideNode(noteLink, 'TBODY'); // return the parent table if exist , otherwise return null
            if (parentTable) {
                parentTable.appendChild(noteContainer);
            } else {
                document.body.appendChild(noteContainer);
            }

            let noteHeight = noteContainer.offsetHeight,
                topOffset = 0,
                leftOffset = 0,
                leftOffsetToTheParent = 0,
                parentWidth = 0,
                parentHeight = 0;

            if (parentTable) {
                topOffset = noteLink.offsetTop;
                leftOffset = noteLink.offsetLeft;
                leftOffsetToTheParent = noteLink.offsetLeft - parentTable.offsetLeft;
                parentWidth = parentTable.offsetWidth;
                parentHeight = parentTable.offsetHeight;
                noteContainer.classList.add('insideTable');
            } else {
                topOffset = noteLink.getBoundingClientRect().top + document.documentElement.scrollTop;
                leftOffset = noteLink.getBoundingClientRect().left;
                leftOffsetToTheParent = noteLink.offsetLeft;
                parentWidth = noteLink.parentElement.offsetWidth;
            }

            if (scroll.isNodeInsideNode(noteLink, 'THEAD')) {
                chevronDown.classList.add('inverse');
                noteContainer.style.top = `${topOffset + 35}px`;
                noteContainer.classList.add('insideHead');
            } else {
                noteContainer.style.top = `${topOffset - noteHeight - 5}px`;
            }
            // to change the left & right direction based on the noteLink position
            if (parentWidth / 2 > leftOffsetToTheParent) {
                noteContainer.style.left = `${leftOffset + 2}px`;
                chevronDown.classList.add('left');
            } else {
                noteContainer.style.left = `${leftOffset - noteContainer.offsetWidth + 22}px`;
                chevronDown.classList.add('right');
            }
            // to change the up & down direction based on the noteLink position
            if (parentHeight / 2 > topOffset) {
                chevronDown.classList.add('inverse');
                noteContainer.style.top = `${topOffset + 35}px`;
            }

            noteClose.addEventListener('click', () => {
                noteLink.setAttribute('aria-expanded', 'false');
                noteLink.removeAttribute('aria-controls');
                noteContainer.remove();
            });
        },
        // embo customization
        scrollToTarget: function ($el, refID) {
            var $target = null,
                fixedElementsHeight = null,
                offset = null;
            if (refID) {
                $target = $(document.getElementById($el.hash.slice(1)));
            } else {
                $target = $el;
            }

            $target = $target.length ? $target : $('[name="' + $el.hash.slice(1) + '"]');

            fixedElementsHeight = UX.scrollo.get.fixedpageElementsHeight();
            offset = $target.offset().top;

            if ($target.length) {
                $('html,body').animate(
                    {
                        scrollTop: offset - fixedElementsHeight,
                    },
                    500
                );
                setTimeout(function () {
                    $target.find('a').eq(0).focus();
                }, 1000);
            }
        },

        isIE: function () {
            var browsers = {
                isIE: /*@cc_on!@*/ false || !!document.documentMode,
            };
            return browsers['isIE'];
        },
        createFootNote: noteLink => {
            const noteContainer = document.createElement('div'),
                noteClose = document.createElement('button'),
                closeIcon = document.createElement('i'),
                noteItem = document.createElement('div'),
                chevronDown = document.createElement('span');

            noteContainer.classList.add('footNotePopup');
            noteClose.classList.add('footNoteClose');
            closeIcon.classList.add('icon-tools_close');
            closeIcon.setAttribute('aria-hidden', 'true');
            noteItem.classList.add('footNotePopup__item');
            chevronDown.classList.add('chevronDown');
            noteContainer.appendChild(noteClose);
            noteContainer.appendChild(noteItem);
            noteContainer.appendChild(chevronDown);
            noteClose.appendChild(closeIcon);

            const noteID = noteLink.getAttribute('data-noteid'),
                controllerId = noteLink.getAttribute('id'),
                popupId = noteLink.getAttribute('href').substring(1), // to remove '#'
                noteContent = document.querySelector(`li#${noteID}`).innerHTML;

            noteItem.innerHTML = noteContent;
            noteLink.setAttribute('aria-expanded', 'true');
            noteContainer.setAttribute('id', popupId);
            noteLink.setAttribute('aria-controls', popupId);
            noteContainer.setAttribute('aria-labelledby', controllerId);

            return {noteContainer, chevronDown, noteClose};
        },

        // to determine if the notelink exist inside XYZ node or not because different styles going to be applied if yes.
        // return false if not , if true return the XYZ node itself .
        isNodeInsideNode: function (node, parentNode) {
            if (node.tagName === parentNode) return node;
            return node.parentNode !== document.body && this.isNodeInsideNode(node.parentNode, parentNode);
        },
    };

    UX.scroll = scroll;
})();
